import Icon from '../components/Icon.vue'

Icon.register({
  bomb: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M440.5 88.5l-52 52 26.5 26.5c9.4 9.4 9.4 24.6 0 33.9l-17.4 17.4c11.8 26.1 18.4 55.1 18.4 85.6 0 114.9-93.1 208-208 208s-208-93-208-207.9 93.1-208 208-208c30.5 0 59.5 6.6 85.6 18.4l17.4-17.4c9.4-9.4 24.6-9.4 33.9 0l26.5 26.5 52-52zM500 60c6.6 0 12 5.4 12 12s-5.4 12-12 12h-24c-6.6 0-12-5.4-12-12s5.4-12 12-12h24zM440 0c6.6 0 12 5.4 12 12v24c0 6.6-5.4 12-12 12s-12-5.4-12-12v-24c0-6.6 5.4-12 12-12zM473.9 55c-4.6 4.7-12.2 4.7-17 0-4.7-4.7-4.7-12.3 0-17l17-17c4.7-4.7 12.3-4.7 17 0 4.7 4.7 4.7 12.3 0 17zM406.1 55l-17-17c-4.7-4.7-4.7-12.3 0-17 4.7-4.7 12.3-4.7 17 0l17 17c4.7 4.7 4.7 12.3 0 17-4.7 4.7-12.3 4.7-17 0zM473.9 89l17 17c4.7 4.7 4.7 12.3 0 17-4.7 4.7-12.3 4.7-17 0l-17-17c-4.7-4.7-4.7-12.3 0-17 4.7-4.7 12.3-4.7 17 0zM112 272c0-35.3 28.7-64 64-64 8.8 0 16-7.2 16-16s-7.2-16-16-16c-52.9 0-96 43.1-96 96 0 8.8 7.2 16 16 16s16-7.2 16-16z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/bomb.js
// module id = 671
// module chunks = 0